const DB_NAME = 'ecommerce_db';
let DB_VERSION = 1;
let DB;

export default {

	async getDb(name='c') {
		return new Promise((resolve, reject) => {

			if(DB) { return resolve(DB); }
			// console.log('OPENING DB', DB);
			let request = window.indexedDB.open(DB_NAME, DB_VERSION);
			
			request.onerror = e => {
				console.log('Error opening db', e);
				reject('Error');
			};
	
			request.onsuccess = e => {
				DB = e.target.result;
				resolve(DB);
			};
			// console.log(name);
			request.onupgradeneeded = e => {
				let db = e.target.result;
				db.createObjectStore(name, { autoIncrement: true, keyPath:'id' });
			};
		});
	},
	async deleteDat(name='c') {

		let db = await this.getDb(name);
        // console.log(name);
		return new Promise(resolve => {

			let trans = db.deleteObjectStore(name)// transaction([name],'readwrite');
			trans.oncomplete = () => {
				resolve();
			};

			// let store = trans.objectStore(name);
			// store.delete(cat.id);
            // store.delete();
		});	
	},
	async getDats(name='c') {

		let db = await this.getDb(name);

		return new Promise(resolve => {

			let trans = db.transaction([name],'readonly');
			trans.oncomplete = () => {
				resolve(dats);
			};
			
			let store = trans.objectStore(name);
			let dats = [];
			
			store.openCursor().onsuccess = e => {
				let cursor = e.target.result;
				if (cursor) {
					dats.push(cursor.value)
					cursor.continue();
				}
			};

		});
	},

	async saveDat(dat,name='c') {
		let db = await this.getDb(name);
		// console.log(dat,name);
		return new Promise(resolve => {

			let trans = db.transaction([name],'readwrite');
			trans.oncomplete = () => {
				resolve();
			};

			let store = trans.objectStore(name);
			store.put(dat);

		});
	
	}

}